<template>
	<div class="sure-Information">
		<button class="surebtn" @click="toback">返回</button>
		<div class="big-box">
			<div class="title">信息确认</div>
			<div class="info-box">
				<div class="info-left">医院</div>
				<div class="info-right">{{ form.hospitalName }}</div>
			</div>
			<div class="info-box">
				<div class="info-left">科室</div>
				<div class="info-right">{{ form.deptName }}</div>
			</div>
			<div class="info-box">
				<div class="info-left">医生</div>
				<div class="info-right">{{ form.doctorName }}</div>
			</div>
			<div class="info-box">
				<div class="info-left">费用</div>
				<div class="info-right">{{ form.unitPrice }}元</div>
			</div>
			<div class="info-box">
				<div class="info-left">预约时间</div>
				<div class="info-right">{{ form.orderTime }}</div>
			</div>
			<div
				v-if="relationRecords && relationRecords.length > 0"
				class="info-box"
			>
				<div class="info-left">就诊人</div>
				<div class="info-right">
					<a-dropdown>
						<span @click="(e) => e.preventDefault()">
							{{ form.userName }}
							<a-icon type="caret-down" />
						</span>
						<a-menu slot="overlay">
							<a-menu-item
								@click="changeUser(item)"
								v-for="(item, index) in relationRecords"
								:key="index"
							>
								<a href="javascript:;">{{ item.name }}</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</div>
			</div>
			<div class="info-box" v-if="sourceShow">
				<div class="info-left">预约来源</div>
				<div class="info-right">
					<a-dropdown>
						<span @click="(e) => e.preventDefault()">
							{{ yuyuefromlabel }}
							<a-icon type="caret-down" />
						</span>
						<a-menu slot="overlay">
							<a-menu-item
								@click="changeyyFrom(item)"
								v-for="(item, index) in yyfromList"
								:key="index"
							>
								<a href="javascript:;">{{ item.name }}</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</div>
			</div>
			<div class="add-patient" @click="addRegister">+添加就诊人</div>
			<div class="remake-box">
				<div class="remake-name">挂号须知</div>
				<pre v-if="hospital.reserveInfo"
					>{{ hospital.reserveInfo }}
        </pre
				>
				<pre v-else>
1、本系统要求实名挂号，且需支付挂号费；
2、每个身份证挂号限制：限同时挂号三次，每个科室限挂一次，每月6次；
3.请携带身份证、就诊卡前往对应科室就诊、检验、治疗、取药等；
4、如需取消预约，请在预约时间24小时前在“我-我的挂号”申请取消、退款；当天当班不就诊，医院不再安排就诊及退费；
5、如需索取发票，请咨询医院挂号处。
        </pre
				>
			</div>
			<a-button
				type="primary"
				@click="goOrder"
				class="btn cursor-point hp_center"
				>提交订单</a-button
			>
		</div>
		<Register-card ref="zcBind"></Register-card>
	</div>
</template>
<script>
import RegisterCard from '@/components/RegisterCard'
import { byHospId } from '@/api/register'
import { ls } from '@/utils/tool'
import {
	setOrderPay,
	getHospitalDetail,
	getOrderDetail,
	checkYuyueFrom,
} from '@/api/payment'
export default {
	components: {
		RegisterCard,
	},
	data() {
		return {
			form: {
				userName: '',
				recordId: '',
				yuyuefrom: 3,
			},
			yuyuefromlabel: '医联体',
			yyfromList: [
				{ name: '线上', value: 1 },
				{ name: '医联体', value: 3 },
			],
			relationRecords: ls.get('sysUser').relationRecords,
			hospitalId: '',
			hospitalInfo: [],
			hospital: {},
			aModal: false,
			orderId: '0',
			sourceShow: false,
		}
	},
	created() {
		this.hospitalId = this.$route.query.hospitalId
		this.form = { ...this.form, ...this.$route.query }
		checkYuyueFrom({ hospId: this.hospitalId }).then((res) => {
			this.sourceShow = res.data
		})
		if (this.relationRecords && this.relationRecords.length > 0) {
			this.form.userName = this.relationRecords[0].name
			this.form.recordId = this.relationRecords[0].recordId
		}
		this.getHospitalDetail()
	},
	mounted() {},
	methods: {
		//获取医院详情
		async getHospitalDetail() {
			var res = await getHospitalDetail(this.hospitalId)
			if (res.code == 200) {
				this.hospital = res.data
				if (res.data.reserveInfo) {
					this.hospitalInfo = res.data.reserveInfo.split('\n') || []
				}
			}
		},
		changeUser(item) {
			this.form.userName = item.name
			this.form.recordId = item.recordId
		},
		changeyyFrom(item) {
			this.form.yuyuefrom = item.value
			this.yuyuefromlabel = item.name
		},
		addRegister() {
			if (ls.get('sysUser').relationRecords.length >= 5) {
				this.$message.error('可关联就诊卡已到上限！')
			} else {
				this.$refs.zcBind.onShow()
			}
		},
		//返回按键
		toback() {
			this.$router.go(-1)
		},
		//提交订单
		async goOrder() {
			if (!this.form.recordId) {
				this.$message.error('请选择就诊人')
				return
			}
			var arr = this.form.orderTime.split(' ')
			var str = arr[0] + ',' + arr[1].replace('-', ',')
			var data = {
				doctorId: this.form.doctorId,
				memberId: ls.get('sysUser').id,
				orderTime: str,
				recordId: this.form.recordId,
				schId: this.form.schId,
				srcId: this.form.srcId,
				yuyuefrom: this.sourceShow ? this.form.yuyuefrom : '',
			}
			console.log(this.form, data, this.hospital)
			var rs = await setOrderPay(data)
			console.log('rs=====', rs)

			if (rs.code == 200) {
				// 0是非人工不可直接预约成功需要支付
				// 人工排班类型的医院去医院支付,直接跳转预约成功即可
				// hospital.needPay==2 是像第一人民医院这种无需支付直接跳转的医院 需特殊处理
				if (
					this.hospital.handSchFlg === '0' &&
					this.hospital.needPay != 2
				) {
					this.$router.push({
						name: 'payment',
						query: {
							id: rs.data.orderId,
							time: this.form.orderTime,
						},
					})
				} else {
					this.aModal = true
					var res = await getOrderDetail(rs.data.orderId)
					if (res.code !== 200) {
						this.$message.error(res.message)
						return
					}
					this.aModal = false
					this.$router.push({
						name: 'pay-success',
						query: {
							id: rs.data.orderId,
							time: this.form.orderTime,
							reveal: 1,
						},
					})
				}
			} else {
				this.$message.error(rs.message)
			}
		},
	},
}
</script>
<style lang="less" scoped>
.sure-Information {
	width: 1200px;
	margin: 0 auto;
	position: relative;
	.surebtn {
		position: absolute;
		top: 0;
		left: 20px;
		// color: blue;
		cursor: pointer;
		background: #fff;
		border: 1px solid #ccc;
		padding: 10px 15px;
	}
	.big-box {
		width: 980px;
		margin: 0 auto;
		.title {
			text-align: center;
			font-size: 40px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			margin-bottom: 30px;
			margin-top: 60px;
		}
		.info-box {
			width: 100%;
			height: 77px;
			background: #ffffff;
			box-shadow: 0px 0px 6px 0px rgba(69, 157, 247, 0.19);
			border-radius: 6px;
			display: flex;
			justify-content: space-between;
			line-height: 77px;
			padding: 0 57px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			margin-bottom: 10px;
			.info-left {
				font-size: 20px;
				color: #797979;
			}
			.info-right {
				font-size: 20px;
				color: #2a2a2a;
			}
		}
		.add-patient {
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #3385ed;
			text-align: center;
			margin: 30px 0;
		}
		.remake-box {
			font-family: Source Han Sans CN;
			font-weight: 400;
			.remake-name {
				font-size: 20px;
				color: #333333;
				margin-bottom: 30px;
			}
			pre {
				white-space: pre-wrap;
				word-wrap: break-word;
				font-size: 16px;
				color: #999999;
				line-height: 42px;
			}
		}
		.btn {
			width: 100%;
			height: 83px;
			background: #3385ed;
			border-radius: 10px;
			font-size: 28px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #fffefe;
		}
	}
}
</style>
